import { render, staticRenderFns } from "./oring-conf.vue?vue&type=template&id=1c5a5b8c&scoped=true"
import script from "./oring-conf.vue?vue&type=script&lang=js"
export * from "./oring-conf.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c5a5b8c",
  null
  
)

export default component.exports